import React from 'react';

const ReadOnly = ({ readOnly, children }) => {
  return (
    readOnly ?
    (
      <>
        <div className="mb-2">
          <span className="font-bold">Read Only.</span> 
          <p>You may edit this information after you sign up.</p>
        </div>
        <div className="relative">
          <div className="absolute h-full w-full bg-gray-400 top-0 opacity-25 z-10" />
          {children}
        </div>
      </>
    ) : children
  );
}

export default ReadOnly;